
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[code]",
      function () {
        return require("private-next-pages/event/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[code]"])
      });
    }
  